import Vue from 'vue'
import App from './App.vue'
import router from './router'
import echarts from 'echarts'; 
Vue.prototype.$echarts = echarts;
//element
import 'element-ui/lib/theme-chalk/index.css';
import { Message,Notification } from "element-ui";
Vue.prototype.$message = Message;
Vue.prototype.$notify = Notification;
import axios from "axios";
// axios.defaults.baseURL = 'https://gemsbaby.com';
axios.defaults.baseURL = '/';
//axios.defaults.baseURL = VUE_APP_BASE_API;
// let ROOT;
// if (process.env.NODE_ENV === 'development') {
//     ROOT = "/";//开发环境下的代理地址，解决本地跨域
// } else {
//     ROOT = 'https://gemsbaby.com';    //生产环境下的地址
// }
// axios.defaults.baseURL = ROOT;
Vue.prototype.$axios = axios;
axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded; charset=UTF-8";
import qs from "qs";
Vue.prototype.qs = qs;

//请求的拦截器
axios.interceptors.request.use(
  function (config) {
    if (config.method === "post") {
      let data = qs.parse(config.data);
      config.data = qs.stringify({
        ...data
      });
    } else if (config.method === "get") {
      config.params = {
        ...config.params
      };
    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
  router
}).$mount('#app')
